export const libsMap: { [key: string]: any } = {
  // echarts: `${process.env.STATIC_RES_DOMAIN}/libs/echarts/5.1.2/echarts-flow.min.js`,
  // 与 console-pc 的直播巡检使用相同厂商 SDK。
  YDPlayer: `${process.env.STATIC_RES_DOMAIN}/libs/ydplayer/20220728/ydplayer-compatible.js`,
  jPlayer: '/player.js',
  uLink: 'https://g.alicdn.com/jssdk/u-link/index.min.js',
  // UI组件库： https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.23&manage_type=myprojects&projectId=2105876&keyword=&project_type=&page=
  iconUI: 'https://at.alicdn.com/t/c/font_2105876_p45a97nv27a.js',
  // location图标： https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.23&manage_type=myprojects&projectId=1493136&keyword=&project_type=&page=
  // <!-- <script src="//at.alicdn.com/t/c/font_1493136_c4ga5slhuec.js"></script> -->
  iconApp: '//at.alicdn.com/t/c/font_1493136_q9y36l8rhbm.js',
  // location图标（新）：https://www.iconfont.cn/manage/index?manage_type=myprojects&projectId=4982067
  // at.alicdn.com/t/c/font_4982067_3u8l6ala5d3.css
  iconAppNew: '//at.alicdn.com/t/c/font_4982067_xagekov7cas.js',
  iconAppNewCss: '//at.alicdn.com/t/c/font_4982067_xagekov7cas.css',
  // locatioin_pc https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.23&manage_type=myprojects&projectId=1879396&keyword=&project_type=&page=
  iconPC: '//at.alicdn.com/t/c/font_1879396_rhdtxq7404m.js',
  // location-pc新iconfont地址，带前缀，避免重名覆盖
  // https://www.iconfont.cn/manage/index?manage_type=myprojects&projectId=4974122
  iconPCNew: '//at.alicdn.com/t/c/font_4974122_wv1ysxuhpy.js',
  // 企业微信 SDK
  iosJweixin: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
  jwxwork: 'https://res.wx.qq.com/wwopen/js/jsapi/jweixin-1.0.0.js',
  jwxwecom: 'https://wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.3.3.js'
};
